<template>
  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="tariff_is_load" parent="tariff">
    <tab id="info" :name="translate('tariff.section.info')" :href="url+'/info'">
      <TariffInfo v-if="tariff_is_load"
        :tariffs="tariff_info"
        @update="update_tariff"
      />
    </tab>

    <tab id="packets" :name="translate('tariff.section.packets')" :href="url+'/packets'">
      <TariffPackets
          :packets="tariff_info.packets"
      />
    </tab>

    <tab id="services" :name="translate('tariff.section.services')" :href="url+'/services'">
      <TariffServices
          :services="tariff_info.services"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Tariff: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/tariffs_list'}">
              To Tariff list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import TariffInfo from './Tabs/Info/Index.vue'
import TariffPackets from "./Tabs/Packets/Index.vue";
import TariffServices from "./Tabs/Services/Index.vue";

export default {
  name: 'Tariff',
  components: {
    TariffInfo,
    TariffPackets,
    TariffServices,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      tariff_info: null,
    }
  },

  computed: {
    url () { return '/tariff/' + this.$route.params.tariff_id },
    cur_id () { return this.$route.params.tariff_id },
    load () { return !this.tariff_info?.id },
    tariff_is_load() { return this.tariff_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'tariff_section') {
        this.get_tariff()
      }
    }
  },

  activated(){
    this.get_tariff()
  },

  methods: {
    update_tariff(new_tariff_info){
      this.tariff_info = new_tariff_info
      this.$store.commit('updateSelectedTariff', new_tariff_info)
    },
    get_tariff () {
      this.$http.v1.getTariffInfo(this.$route.params.tariff_id, (response) => {
        this.tariff_info = response.data
        this.$store.commit('updateSelectedTariff', response.data)
      })
    }
  }
}

</script>
